export default {"src":"/job-search/_next/static/media/image-catchphrase-center.60317989.svg","height":207,"width":367,"blurWidth":0,"blurHeight":0};